import { render } from "./UserOutOfOfficeSettings.vue?vue&type=template&id=828383ac"
import script from "./UserOutOfOfficeSettings.vue?vue&type=script&lang=ts"
export * from "./UserOutOfOfficeSettings.vue?vue&type=script&lang=ts"
script.render = render

export default script